// components/OnDemandTour/DashboardMirrorModal.tsx

import {
    Modal, PageHeader, Space, Switch, Typography,
} from 'antd';
import React from 'react';
import { DashboardMirror } from '..';

const { Text } = Typography;

interface DashboardMirrorModalProps {
  open: boolean;
  onClose: () => void;
  selectionMode: boolean;
  onToggleSelection: () => void;
  onElementSelected: (selector: string) => void;
  isEditingTour: boolean;
  tourStartUrl?: string;
}

const DashboardMirrorModal: React.FC<DashboardMirrorModalProps> = ({
    open,
    onClose,
    selectionMode,
    onToggleSelection,
    onElementSelected,
    isEditingTour,
    tourStartUrl,
}) => (
    <Modal
        title={null}
        open={open}
        onCancel={onClose}
        footer={null}
        width="80%"
        destroyOnClose
        centered
        closeIcon={(
            <div
                style={{
                    fontSize: '20px',
                    color: '#fff',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                }}
            >
                ✕
            </div>
        )}
    >
        <PageHeader
            title="Dashboard Mirror"
            subTitle="Interactive dashboard preview for tour element selection"
            style={{ padding: '16px 0' }}
            extra={[
                <Space key="selection-mode" align="center" size={8}>
                    <Text>Selection mode:</Text>
                    <Switch
                        checked={selectionMode}
                        onChange={onToggleSelection}
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                    />
                </Space>,
            ]}
        >
            <Text type="secondary" style={{ fontSize: '14px' }}>
                Este es un mirror del Dashboard que permite navegar e interactuar con normalidad.
                Cuando el modo selección está
                {' '}
                <Text strong>activado</Text>
                , puedes hacer clic en cualquier elemento
                para capturar su selector CSS. Cuando está
                {' '}
                <Text strong>desactivado</Text>
                , puedes navegar
                libremente por el dashboard.
            </Text>
        </PageHeader>
        <DashboardMirror
            selectionMode={selectionMode}
            onElementSelected={onElementSelected}
            isEditingTour={isEditingTour}
            tourStartUrl={tourStartUrl}
        />
    </Modal>
);

export default DashboardMirrorModal;
